import { render, staticRenderFns } from "./NEOHistorical.vue?vue&type=template&id=b42da550&scoped=true&"
import script from "./NEOHistorical.vue?vue&type=script&lang=js&"
export * from "./NEOHistorical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42da550",
  null
  
)

export default component.exports